import React, { Component, Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import get from 'lodash.get';

// once this gets put into its own dibs-component, use that instead
import { VisibilityTracker } from './VisibilityTracker';

import { LoadingSpinner } from '../../finding/SbSharedTradeBenefitPlacement/LoadingSpinner';

import styles from './TradeRewardsMessagingWrapper.scss';

class TradeRewardsMessagingWrapperComponent extends Component {
    constructor(props) {
        super(props);

        this.messageWrapperRef = React.createRef();

        this.state = {
            SbSharedTradeBenefitPlacement: null,
            RewardsMessageProvider: null,
            PLACEMENT_TYPE_EDUCATION: null,
            displayProvider: false,
        };
    }

    componentDidMount() {
        return Promise.all([
            import(
                /* webpackChunkName: "rewards-messaging-provider" */ 'dibs-trade-rewards-progress/exports/RewardsMessageProvider'
            ),
            import(
                /* webpackChunkName: "trade-loyalty-messages-placement" */ '../../finding/SbSharedTradeBenefitPlacement/SbSharedTradeBenefitPlacement'
            ),
        ]).then(chunks => {
            const [
                { RewardsMessageProvider, PLACEMENT_TYPE_EDUCATION },
                { SbSharedTradeBenefitPlacement },
            ] = chunks;

            this.setState({
                RewardsMessageProvider,
                SbSharedTradeBenefitPlacement,
                PLACEMENT_TYPE_EDUCATION,
            });
        });
    }

    onContentVisible = () => {
        this.setState({ displayProvider: true });
    };

    render() {
        const tradeFirm = get(this.props, 'user.tradeFirm') || null;
        const userId = get(this.props, 'user.serviceId') || null;

        const { RewardsMessageProvider, PLACEMENT_TYPE_EDUCATION } = this.state;
        const offsetVertical = 300;

        const displaySpinner =
            !this.state.displayProvider || !RewardsMessageProvider || !PLACEMENT_TYPE_EDUCATION;

        return (
            <div className={styles.wrapper}>
                <div className={styles.container} ref={this.messageWrapperRef}>
                    {displaySpinner ? (
                        <Fragment>
                            <VisibilityTracker
                                onContentVisible={this.onContentVisible}
                                elementRef={this.messageWrapperRef}
                                options={{
                                    rootMargin: `${offsetVertical}px 0px ${offsetVertical}px 0px`,
                                }}
                            />
                            <LoadingSpinner />
                        </Fragment>
                    ) : (
                        <RewardsMessageProvider
                            placementType={PLACEMENT_TYPE_EDUCATION}
                            tradeFirm={tradeFirm}
                        >
                            {({ program, updateLocalStorage }) => {
                                const { SbSharedTradeBenefitPlacement } = this.state;

                                if (!program || !SbSharedTradeBenefitPlacement) {
                                    return <LoadingSpinner />;
                                }

                                return (
                                    <SbSharedTradeBenefitPlacement
                                        environment={this.props.environment}
                                        userId={userId}
                                        program={program}
                                        updateLocalStorage={updateLocalStorage}
                                    />
                                );
                            }}
                        </RewardsMessageProvider>
                    )}
                </div>
            </div>
        );
    }
}

TradeRewardsMessagingWrapperComponent.propTypes = {
    user: PropTypes.object,
    environment: PropTypes.object,
};

export const TradeRewardsMessagingWrapper = createFragmentContainer(
    TradeRewardsMessagingWrapperComponent,
    {
        user: graphql`
            fragment TradeRewardsMessagingWrapper_user on User {
                serviceId
                tradeFirm @include(if: $isTrade) {
                    ...RewardsMessageProvider_tradeFirm
                }
            }
        `,
    }
);
